
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import PageLayout from "@/components/layout/PageLayout";
import { NewClientForm } from "@/components/admin/new-client/NewClientForm";
import { AdminCheck } from "@/components/admin/new-client/AdminCheck";
import AdminLayout from "@/components/layout/AdminLayout";

const NewClientPage = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          navigate("/auth");
          return;
        }

        const { data: roleData } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', session.user.id)
          .in('role', ['admin', 'producer'])
          .single();

        if (!roleData) {
          toast({
            variant: "destructive",
            title: "Access Denied",
            description: "You don't have permission to access this page."
          });
          navigate("/dashboard");
          return;
        }
        
        setIsLoading(false);
      } catch (error) {
        console.error("Error checking access:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "An unexpected error occurred. Please try again."
        });
        navigate("/dashboard");
      }
    };

    checkAccess();
  }, [navigate, toast]);

  if (isLoading) return (
    <PageLayout>
      <div className="flex justify-center items-center min-h-screen">
        <p>Loading...</p>
      </div>
    </PageLayout>
  );

  return (
    <AdminLayout title="New Client">
      <AdminCheck>
        <div className="mt-4 max-w-4xl mx-auto">
          <NewClientForm />
        </div>
      </AdminCheck>
    </AdminLayout>
  );
};

export default NewClientPage;
